module.exports = __webpack_public_path__ + "img/664-ae1fe7.png";